import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const DashboardContext = createContext();

export const useDashboard = () => useContext(DashboardContext);

export const DashboardProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const loadedRef = useRef(false);

  const save = useCallback((newData) => {
    setData(newData);
    loadedRef.current = true;
  }, []);

  const clear = useCallback(() => {
    setData(null);
    loadedRef.current = false;
  }, []);

  const isLoaded = loadedRef.current;

  return (
    <DashboardContext.Provider value={{ data, save, clear, isLoaded }}>
      {children}
    </DashboardContext.Provider>
  );
};
